import { Stack, Typography } from '@mui/material';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import DefaultLayout from 'layouts/defaultLayout';
import { ErrorPageStackStyles } from './404.styles';

const ErrorPage = () => (
  <DefaultLayout renderStepper={false}>
    <Stack gap={4} sx={ErrorPageStackStyles}>
      <Typography variant="h1">404</Typography>

      <Typography variant="h1">Page not found</Typography>

      <PrimaryButton text="Back to Home Page" href="/" />
    </Stack>
  </DefaultLayout>
);

export default ErrorPage;
